import React, { Component, PropTypes } from 'react';
import { Message, Button as SparkButton } from 'sabre-spark-react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Button } from 'sabre-spark-react';
import { CodeEditor } from './CodeEditor';
import { CATEGORIES, FileService } from '../../../services/fileUpload/uploadFile';
import './CodeEditorPanel.scss';
import { SAVE_LEVEL } from '../../../constants/Level';
import store from '../../../store/Store';
import ModalAssetBrowser from '../ModalAssetBrowser';
import { DialogModal } from './DialogModal';
import AssetUploader from '../AssetUploader';

const noop = () => {};
const MESSAGES = {
    FILE_NOT_EXISTS: { type: 'warning', title: 'File does not exist' },
    SAVE_SUCCESSFUL: { type: 'success', title: 'File was saved successfully' }
};

class CodeEditorPanel extends Component {
    static defaultProps = {
        title: '',
        editedSection: '',
        file: null,
        category: null,
        editorProfile: 'default',
        caretTarget: null,
        languageCode: '',
        saveType: '',
        onSave: noop,
        onCancel: noop,
        onError: noop,
        onAssetSelected: noop,
        onBeforeSave: noop,
        generateFileName: function() {
            const { chainId, hotelId, level, themeCode, configCode, saveType } = this.props;
            const codeToUse = saveType === 'config' ? configCode : themeCode;
            const { title, languageCode } = this.state;
            return `${chainId}${level === SAVE_LEVEL.HOTEL ? '_' + hotelId : ''}_${codeToUse}_${title
                .replace(':', '')
                .replace(/[\s-]+/g, '-')
                .toLowerCase()}_${languageCode.toLowerCase()}.html`;
        },
        mode: 'htmlmixed'
    };

    static propTypes = {
        title: PropTypes.string,
        editedSection: PropTypes.string,
        file: PropTypes.string,
        category: PropTypes.string,
        editorProfile: PropTypes.string,
        languageCode: PropTypes.string,
        saveType: PropTypes.string,
        caretTarget: PropTypes.element,
        onSave: PropTypes.func,
        onBeforeSave: PropTypes.func,
        onCancel: PropTypes.func,
        onError: PropTypes.func,
        onAssetSelected: PropTypes.func,
        generateFileName: PropTypes.func,
        mode: PropTypes.string,
        permission: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.editorRef = null;
        this.state = {
            value: '',
            title: props.title || '',
            editedSection: props.editedSection || '',
            languageCode: props.languageCode,
            file: props.file,
            changed: false,
            message: null,
            caretOffsetTop: 0,
            showAssetBrowser: false,
            empty: true
        };

        this.handleOnChange = this.handleOnChange.bind(this);
        this.save = this.save.bind(this);
        this.cancelEdit = this.cancelEdit.bind(this);
    }
    openAssetBrowser() {
        this.setState({
            showAssetBrowser: true
        });
    }
    componentDidMount() {
        this.switchToFile(this.state.file);
        this.updateCaretPosition(this.props.caretTarget);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.file !== prevState.file) {
            this.switchToFile(this.state.file);
        }
    }
    componentWillReceiveProps(nextProps) {
        const action = () => {
            this.setState({
                file: nextProps.file,
                title: nextProps.title || '',
                languageCode: nextProps.languageCode,
                editedSection: nextProps.editedSection || '',
                changed: false
            });
            this.updateCaretPosition(nextProps.caretTarget);
        };
        if (
            this.editorRef.cm.getValue() &&
            (nextProps.file !== this.props.file ||
                this.props.title !== nextProps.title ||
                nextProps.languageCode !== this.props.languageCode ||
                this.props.editedSection !== nextProps.editedSection ||
                nextProps.caretTarget !== this.props.caretTarget)
        ) {
            this.dialogRef.ask(() => this.save(), action, this.state.changed);
        } else {
            action();
        }
    }
    switchToFile(file) {
        if (file) {
            this.setState({
                value: 'Loading...',
                changed: false
            });
            FileService.getByName(file)
                .then(response => {
                    this.setState(
                        {
                            value: response.data,
                            empty: false,
                            message: null
                        },
                        () => {
                            this.editorRef.cm.clearHistory();
                        }
                    );
                })
                .catch(result => {
                    const { editedSection, languageCode } = this.state;
                    if (get(result, 'response.status') === 404) {
                        this.setState(
                            {
                                value: '',
                                changed: false,
                                empty: true,
                                message: MESSAGES.FILE_NOT_EXISTS
                            },
                            () => {
                                this.editorRef.cm.clearHistory();
                            }
                        );
                        //Trigger theme value update
                        this.props.onSave(languageCode, editedSection, '');
                        return Promise.resolve();
                    }
                });
        } else {
            this.setState(
                {
                    value: '',
                    changed: false,
                    empty: true
                },
                () => {
                    this.editorRef.cm.clearHistory();
                }
            );
        }
    }
    updateCaretPosition(caretTarget) {
        if (caretTarget) {
            const update = Math.max(
                get(this.editorRef, 'textareaNode.offsetTop', 0),
                caretTarget.offsetHeight / 2 + caretTarget.offsetTop
            );
            this.setState({
                caretOffsetTop: update
            });
        } else {
            this.setState({
                caretOffsetTop: 0
            });
        }
    }
    handleOnChange(value) {
        this.setState({
            changed: value !== this.state.value,
            empty: !value
        });
    }
    cancelEdit() {
        this.setState({
            title: '',
            changed: false,
            value: ''
        });
        this.props.onCancel();
    }
    onSave(languageCode, section, response) {
        this.setState({
            changed: false,
            loading: false
        });
        this.props.onSave(languageCode, section, response);
    }
    onError(section, response) {
        this.props.onError(section, response);
    }
    onAssetSelected(asset) {
        this.props.onAssetSelected(asset);
    }
    onBeforeSave(languageCode, editedSection) {
        this.setState(
            {
                loading: true
            },
            () => {
                this.props.onBeforeSave(languageCode, editedSection);
            }
        );
    }
    save() {
        const { chainId, hotelId, level } = this.props;
        const { editedSection, languageCode } = this.state;
        const file = new File([this.editorRef.cm.getValue()], this.getFileName());
        this.onBeforeSave(languageCode, editedSection);
        return FileService.upload(chainId, hotelId, level, Object.assign(file, { override: true }), () => {}, {
            category: this.props.category
        }).then(this.onSave.bind(this, languageCode, editedSection), this.onError.bind(this, editedSection));
    }
    getFileName() {
        const { chainId, hotelId, level, themeCode, configCode, saveType } = this.props;
        const { title, languageCode } = this.state;
        if (this.state.file) {
            return this.state.file.split('/').pop();
        }
        const codeToUse = saveType === 'config' ? configCode : themeCode;
        
        return this.props.generateFileName.call(this);
    }
    onResetErrors = () => {
        this.browser && this.browser.resetErrors();
    };
    onRefresh = () => {
        this.browser && this.browser.refresh();
    };
    render() {
        const sections = this.state.editedSection.split('.');
        return (
            <div className="code-editor-panel__wrapper spark-flex">
                <div className={`code-editor-panel spark-flex`}>
                    <div className="code-editor-panel__header">
                        {this.state.title && <h4>{this.state.title}</h4>}
                        {this.state.title && (
                            <p>
                                Enter code that will be injected into the '{sections[0]}' tag on '
                                {sections[1] ? sections[1] : 'every'}' page of the site.
                            </p>
                        )}

                        {/*<div className='col-xs'>
                        <Toolbar tabIndex="0" role="menubar" className="code-editor-panel__toolbar spark-toolbar--icon">
                            <ToolbarItem role="menuitem" tabIndex="-1" label="Undo" skipContentContainer={true} iconClass='spark-icon-arrow-curve-left' onClick={(e)=>{
                                this.editorRef.cm.undo();
                                e.stopPropagation();
                            }}></ToolbarItem>
                            <ToolbarItem role="menuitem" tabIndex="-2" label="Clear" skipContentContainer={true} iconClass='spark-icon-trash spark-icon--fill' onClick={(e)=>{
                                this.editorRef.cm.setValue('');
                                e.stopPropagation();
                            }}></ToolbarItem>
                        </Toolbar>
                    </div>*/}
                    </div>
                    {this.state.message && <Message {...this.state.message} inline={true} />}
                    <div className="code-editor-panel__editor-wrap">
                        <SparkButton
                            icon={'spark-icon-arrow-curve-left'}
                            disabled={!this.state.changed || this.state.empty}
                            iconOnly={true}
                            className={'fab__undo'}
                            onClick={e => {
                                this.editorRef.cm.undo();
                                e.stopPropagation();
                            }}
                        ></SparkButton>
                        <CodeEditor
                            ref={node => (this.editorRef = node)}
                            defaultValue={this.state.value}
                            disabled={!this.props.permission.edit}
                            onChange={this.handleOnChange}
                            mode={this.props.mode}
                        />
                    </div>
                    {this.props.permission.edit && (
                        <div>
                            <nav className="spark-btn-group">
                                {/*<Button secondary={true} onClick={this.cancelEdit}>Cancel</Button>*/}
                                <Button
                                    loading={this.state.loading}
                                    secondary={true}
                                    onClick={this.save}
                                    disabled={!this.state.changed || this.state.empty || this.state.loading}
                                >
                                    Save file
                                </Button>
                            </nav>
                        </div>
                    )}
                    {this.state.caretOffsetTop ? (
                        <span
                            className="spark-popover__caret"
                            data-position="left"
                            style={{ top: this.state.caretOffsetTop + 'px' }}
                        ></span>
                    ) : (
                        ''
                    )}
                </div>
                <ModalAssetBrowser
                    ref={node => (this.assetBrowser = node)}
                    category={this.props.category}
                    hasAccess={this.props.permission}
                    open={this.state.showAssetBrowser}
                    onClose={value => {
                        this.setState(() => ({ showAssetBrowser: value }));
                    }}
                    store={store}
                    showButton={false}
                    remove={true}
                    onSelect={assets => {
                        if (assets.length >= 1) {
                            let asset = assets[0];
                            this.onAssetSelected(asset);
                        }
                    }}
                    afterSearchBar={
                        <div className="spark-mar-b-1">
                            <div className="spark-mar-b-1">Don’t see the file you need?</div>
                            <AssetUploader
                                metadata={{ category: this.props.category }}
                                multiple={false}
                                hasAccess={_.get(this.props, 'permission.add', true)}
                                store={store}
                                onSuccess={result => {
                                    this.assetBrowser &&
                                        this.assetBrowser
                                            .getWrappedInstance()
                                            .onSearch(get(result, 'data.FilesResult.FileName', ''));
                                }}
                            />
                        </div>
                    }
                />
                <DialogModal ref={node => (this.dialogRef = node)} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        level: state.app.selected.level,
        themeCode: state.app.selected.code,
        configCode: state.app.selected.defaultContentConfig.code
    };
};

const CodeEditorPanelC = connect(mapStateToProps, null, null, { withRef: true })(CodeEditorPanel);
export { CodeEditorPanelC as CodeEditorPanel };



// WEBPACK FOOTER //
// ./src/components/widgets/CodeEditor/CodeEditorPanel.js